export const getCoupons = async () => {
  try {
    const res = await fetch(`/api/all-coupons`);
    const json = await res.json();
    // console.log(json);
    return json;
  } catch (error) {
    console.error(error);
  }
};
export const updateCoupon = async (id, updatedCoupon) => {
  try {
    const options = {
      method: "PUT",
      body: JSON.stringify({ updatedCoupon }),
      headers: { "Content-Type": "application/json" },
    };
    const res = await fetch(`/api/coupon/${id}`, options);
    const json = await res.json();
    // console.log(json);
    return json;
  } catch (error) {
    console.error(error);
  }
};
